import {
    FETCH_VISITS_ROASTER, FETCH_VISITS_ROASTER_ERROR, FETCH_VISITS_ROASTER_START, FETCH_VISITS_ROASTER_SUCCESS,
    CANCEL_APPOINTMENT_EVENT_SUCCESS, CANCEL_APPOINTMENT_EVENT_ERROR, UNDO_VISIT_SUCCESS
} from "../../actions/receptionist/visitsRoasterAction";
import _ from 'lodash';
const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    visitsRoaster: []
};

const visitsRoaster = (state = INIT_STATE, action) => {
    let newState;
    let newVisitsRoaster;
    let index;
    switch (action.type) {
        // case FETCH_VISITS_ROASTER: {
        //     return { ...state };
        // }
        case FETCH_VISITS_ROASTER_START: {
            return { ...state, error: '', message: '', loading: true, visitsRoaster: [] };
        }
        case FETCH_VISITS_ROASTER_SUCCESS: {
            newState = { ...state }
            newState.visitsRoaster = _.cloneDeep(action.visitsRoaster);
            return { ...newState, loading: false }
        }

        case FETCH_VISITS_ROASTER_ERROR: {
            return { ...state, loading: false }
        }
        case CANCEL_APPOINTMENT_EVENT_SUCCESS: {
            newState = { ...state };
            let newVisitsRoaster = [...newState.visitsRoaster];
            index = newVisitsRoaster.findIndex(visitsRoasterItem => visitsRoasterItem.appointmentId === action.visitsRoasterData.appointmentId
                && visitsRoasterItem.eventId === action.visitsRoasterData.eventId
            );
            if (index > -1) {
                newVisitsRoaster.splice(index, 1);
                newState.visitsRoaster = [...newVisitsRoaster];
            }
            return newState;
        }
        case CANCEL_APPOINTMENT_EVENT_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }

        case UNDO_VISIT_SUCCESS: {
            newState = _.cloneDeep(state);

            for (let i = 0; i < newState.visitsRoaster.length; i++) {
                if (newState.visitsRoaster[i].visitNo === action.visit.visitNo && newState.visitsRoaster[i].exam === action.visit.exam) {
                    let selectedVisit = newState.visitsRoaster[i];
                    selectedVisit.start = null;
                    selectedVisit.end = null;
                    newState.visitsRoaster[i] = selectedVisit;
                }
            }
            return { ...newState }
        }

        default: return state;
    }
}
export default visitsRoaster;